/* Memorigin: prices shown in the visitor's currency, checkout stays in the shop currency (HKD).
   Rates: Shopify's daily file (cdn.shopify.com/s/javascripts/currencies.js, relative to USD).
   The cart and checkout are never converted, so what a customer pays is always the HKD figure. */
(function () {
  if (window.__mgCurLoaded) return;
  window.__mgCurLoaded = 1;

  var cfg = window.MG_CUR || {};
  var BASE = cfg.base || 'HKD';
  var LIST = ['HKD', 'USD', 'GBP', 'CNY', 'TWD', 'JPY', 'SGD', 'MYR', 'KRW', 'THB', 'AUD'];
  var BY_COUNTRY = { HK: 'HKD', MO: 'HKD', US: 'USD', GB: 'GBP', CN: 'CNY', TW: 'TWD', JP: 'JPY', SG: 'SGD', MY: 'MYR', KR: 'KRW', TH: 'THB', AU: 'AUD' };
  var SYMBOL = { HKD: 'HK$', USD: 'US$', GBP: '£', CNY: 'CN¥', TWD: 'NT$', JPY: '¥', SGD: 'S$', MYR: 'RM', KRW: '₩', THB: '฿', AUD: 'A$' };
  var KEY = 'mgCurrency';
  /* an HKD price as the theme prints it: HK$49,800.00 or HK$ 49,800 */
  var MONEY = /HK\$\s?(\d{1,3}(?:,\d{3})*(?:\.\d{1,2})?|\d+(?:\.\d{1,2})?)/g;
  var SKIP = 'script,style,noscript,textarea,input,select,option,cart-drawer,cart-drawer-component,.cart-drawer,#CartDrawer,.cart-items,.cart__summary,.cart-summary,[data-mg-no-convert]';

  var rates = null, current = BASE;

  function store(v) { try { localStorage.setItem(KEY, v); } catch (e) {} }
  function stored() { try { return localStorage.getItem(KEY); } catch (e) { return null; } }

  function fmt(amount, code) {
    var n = Math.round(amount);
    var s = n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (SYMBOL[code] || code + ' ') + s;
  }
  function convert(hkd, code) {
    if (!rates || !rates[BASE] || !rates[code]) return null;
    return hkd * rates[BASE] / rates[code];
  }

  /* wrap each HKD price once, remembering the original, then show it in the chosen currency */
  function wrap(root) {
    if (cfg.template === 'cart') return;
    var walker = document.createTreeWalker(root || document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!n.nodeValue || n.nodeValue.indexOf('HK$') < 0) return NodeFilter.FILTER_REJECT;
        var p = n.parentElement;
        if (!p || p.closest(SKIP) || p.closest('.mg-money')) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (n) {
      var text = n.nodeValue, frag = document.createDocumentFragment(), last = 0;
      text.replace(MONEY, function (m, num, idx) {
        if (idx > last) frag.appendChild(document.createTextNode(text.slice(last, idx)));
        var span = document.createElement('span');
        span.className = 'mg-money';
        span.setAttribute('data-hkd', num.replace(/,/g, ''));
        span.setAttribute('data-orig', m);
        span.textContent = m;
        frag.appendChild(span);
        last = idx + m.length;
        return m;
      });
      if (last === 0) return;
      if (last < text.length) frag.appendChild(document.createTextNode(text.slice(last)));
      n.parentNode.replaceChild(frag, n);
    });
  }

  function paint() {
    var effective = current !== BASE && rates && convert(1, current) != null ? current : BASE;
    document.querySelectorAll('[data-mg-display-currency]').forEach(function (l) { if (l.textContent !== effective) l.textContent = effective; });
    document.querySelectorAll('.mg-money').forEach(function (s) {
      var want = s.getAttribute('data-orig');
      if (current !== BASE && rates) {
        var v = convert(parseFloat(s.getAttribute('data-hkd')), current);
        if (v != null) want = fmt(v, current);
      }
      if (s.textContent !== want) s.textContent = want;
    });
    document.querySelectorAll('[data-mg-cur-label]').forEach(function (l) { if (l.textContent !== current) l.textContent = current; });
    document.querySelectorAll('[data-mg-cur]').forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-mg-cur') === current); });
    document.documentElement.classList.toggle('mg-cur-foreign', current !== BASE);
  }

  function choose(code, remember) {
    if (LIST.indexOf(code) < 0) code = BASE;
    current = code;
    if (remember) store(code);
    paint();
  }

  function loadRates(done) {
    if (window.Currency && window.Currency.rates) { rates = window.Currency.rates; return done(); }
    var s = document.createElement('script');
    s.src = 'https://cdn.shopify.com/s/javascripts/currencies.js';
    s.async = true;
    s.onload = function () { rates = (window.Currency && window.Currency.rates) || null; done(); };
    s.onerror = function () { rates = null; done(); };
    document.head.appendChild(s);
  }

  function start() {
    wrap(document.body);
    /* prices the theme redraws later (variant change, recommendations, quick view) */
    /* only real page changes count; our own repainting of a price never triggers another round */
    var pending = [], queued = false;
    function inOwn(node) {
      var el = node.nodeType === 1 ? node : node.parentElement;
      return !!(el && el.closest && el.closest('.mg-money,[data-mg-cur-label],[data-mg-display-currency]'));
    }
    var obs = new MutationObserver(function (list) {
      list.forEach(function (m) {
        if (inOwn(m.target)) return;
        if (m.type === 'characterData') { if (m.target.parentElement) pending.push(m.target.parentElement); return; }
        m.addedNodes.forEach(function (n) { if (!inOwn(n)) pending.push(n.nodeType === 1 ? n : n.parentElement); });
      });
      if (!pending.length || queued) return;
      queued = true;
      requestAnimationFrame(function () {
        var todo = pending; pending = []; queued = false;
        todo.forEach(function (el) { if (el && el.isConnected) wrap(el); });
        paint();
        obs.takeRecords();
      });
    });
    obs.observe(document.body, { childList: true, subtree: true, characterData: true });

    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-mg-cur]');
      if (b) { e.preventDefault(); choose(b.getAttribute('data-mg-cur'), true); var d = b.closest('[data-mg-loc]'); if (d) d.removeAttribute('open'); return; }
      document.querySelectorAll('[data-mg-loc][open]').forEach(function (d) {
        var group = d.closest('.mg-drawer-selectors');
        if (!d.contains(e.target) && !(group && group.contains(e.target))) d.removeAttribute('open');
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') document.querySelectorAll('[data-mg-loc][open]').forEach(function (d) { d.removeAttribute('open'); });
    });

    loadRates(function () {
      var saved = stored();
      if (saved) return choose(saved, false);
      /* first visit: the visitor's own currency, from the country Shopify detects */
      var guess = BY_COUNTRY[cfg.country] || null;
      fetch('/browsing_context_suggestions.json', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          var c = j && j.detected_values && j.detected_values.country && j.detected_values.country.handle;
          choose(BY_COUNTRY[c] || guess || BASE, false);
        })
        .catch(function () { choose(guess || BASE, false); });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
